// extracted by mini-css-extract-plugin
export var bottombar = "about-module--bottombar--3cd17";
export var centerBlock = "about-module--center-block--559cd";
export var container = "about-module--container--41d1b";
export var links = "about-module--links--b537c";
export var subtitle = "about-module--subtitle--48c80";